export const useUnitConverter = () => {
  const convert = (fromUnits, toUnits, value, round = false) => {
    let converted;

    if (fromUnits === toUnits) {
      return value; // No conversion needed
    }

    // Distance
    if (fromUnits === 'mi' && toUnits === 'km') {
      converted = value * 1.609344;
    }

    if (fromUnits === 'km' && toUnits === 'mi') {
      converted = value * 0.621371;
    }

    if (fromUnits === 'ft' && toUnits === 'km') {
      converted = value * 0.0003048;
    }

    if (fromUnits === 'ft' && toUnits === 'm') {
      converted = value / 3.2808399
    }

    if (fromUnits === 'mi' && toUnits === 'm') {
      converted = value * 1609.344;
    }

    if (fromUnits === 'km' && toUnits === 'm') {
      converted = value * 1000;
    }

    if (fromUnits === 'm' && toUnits === 'mi') {
      converted = value * 0.000621371;
    }

    if (fromUnits === 'm' && toUnits === 'km') {
      converted = value / 1000;
    }

    if (fromUnits === 'm' && toUnits === 'ft') {
      converted = value * 3.28084
    }

    // Speed
    if (fromUnits === 'mph' && toUnits === 'kts') {
      converted = value * 1.609344;
    }

    if (fromUnits === 'kts' && toUnits === 'mph') {
      converted = value / 0.868976242;
    }

    if (fromUnits === 'kts' && toUnits === 'kph') {
      converted = value * 1.852
    }

    if (fromUnits === 'kts' && toUnits === 'mps') {
      converted = value * 0.514444444
    }

    if (fromUnits === 'kph' && toUnits === 'mph') {
      converted = value / 1.609344
    }

    if (fromUnits === 'mph' && toUnits === 'kph') {
      converted = value * 1.609344
    }

    // Direction
    if (fromUnits === 'cardinal' && toUnits === 'degs') {
      converted = value === 'N' ? 0
      : value === 'NNE' ? 22.5
      : value === 'NE' ? 45
      : value === 'ENE' ? 67.5
      : value === 'E' ? 90
      : value === 'ESE' ? 112.5
      : value === 'SE' ? 135
      : value === 'SSE' ? 157.5
      : value === 'S' ? 180
      : value === 'SSW' ? 202.5
      : value === 'SW' ? 225
      : value === 'WSW' ? 247.5
      : value === 'W' ? 270
      : value === 'WNW' ? 292.5
      : value === 'NW' ? 315
      : value === 'NNW' ? 337.5
      : 0;
    }
    
    return round ? Math.round(converted) : converted
  }

  return { convert }
}

